export enum GameSettings {
    CASINO,
    VIDEO,
    GAME_SOUND,
    STUDIO_SOUND,
    MUSIC,
    ANIMATION,
    CERTIFICATE,
    LIMITS,
}
